import React from 'react'
import { Link } from 'react-router-dom'
import styles from './QuestionMessage.module.css'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

const QuestionMessage = props => (
  <div className={cx({
    base: true,
    isWrong: props.wrong,
    isCorrect: props.correct,
  })}>
    <div className={styles.title}>
      {props.message.title}
    </div>

    <div className={styles.message}>
      {props.children}

      {props.message.url &&
        <div><br /><Link to={props.message.url} className={styles.link}>{props.message.urlLabel || 'Dit kan hier'}</Link></div>
      }
    </div>
  </div>
)

export default QuestionMessage
